import { Time } from './search-types';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeService {

  constructor() { }

  formatTime(time: Time): string {
    const hour = ((time.hour < 10) ? '0' : '') + time.hour;
    const mins = ((time.minute < 10) ? '0' : '') + time.minute;
    return hour + mins;
  }

  formatDisplayTime(time: Time): string {
    const pad = (num: number) => ((num > 9) ? '' : '0') + num;
    const hour12 = time.hour % 12 === 0 ? 12 : time.hour % 12;
    const period = time.hour < 12 ? 'AM' : 'PM';
    return `${pad(hour12)}:${pad(time.minute)} ${period}`;
  }
  formatDate(date: Date): string {
    if (typeof date === "string") {
      date = new Date(date);
    }
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  }

}
